import React from "react";
import Button from "@mui/material/Button";
import deemedLogo from "../../../resources/assets/logo.png";

import { useNavigate } from "react-router-dom";
import { ApiEndpoint, Method } from "config/constants/apiConstants";
import { api } from "services/ApiService";
import { Alert } from "@mui/material";
import axios from "axios";

export default function ForgetPasswordFrom() {
  const navigate = useNavigate();
  const [email, setEmail] = React.useState("");
  const [error, setError] = React.useState("");
  const onSubmit = async () => {
    let payload = {
      email: email,
      userTypes: ["PATIENT", "GUARDIAN"],
    };
    const data = {
      email: email,
      from: "forgetPassword",
    };

    axios
      .post(ApiEndpoint.FORGOT_PASSWORD, payload)
      .then((res) => {
        navigate("/otpScreen", { state: data });
      })
      .catch((err) => {
        // console.log(err.response.data.message);
        setError(err.response.data.message);
      });
  };
  return (
    <>
      <div className="log_card2">
        <h3 className="welcome_text2">Forget Password</h3>
        <p className="welcome_des2 margin-bottom-fp">
          Enter your email for the verification processes, we will send 4 digits
          code to your email.
        </p>
        <div className="password_wrapper2">
          <input
            type="text"
            className="log_input_password2"
            placeholder="Email"
            onChange={(e) => setEmail(e.target.value)}
          />
        </div>
        {error && (
          <Alert severity="error" style={{ margin: "8px" }}>
            {error}
          </Alert>
        )}
        <div className="fp_continuef marginBottom">
          {/* <button
        className="gradientButton"
        type="submit"
        onClick={onSubmit}
      >
        Continue
      </button> */}
          <Button
            variant="contained"
            type="submit"
            className="payBtn log_submit_btn"
            onClick={(e) => {
              onSubmit();
            }}
          >
            Continue
          </Button>
        </div>
      </div>
    </>
  );
}
